import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto 0 auto;

  .conditions-wrapper {
    padding: 0 3rem 2rem 3rem;
  }

  p {
    text-align: left;
  }
`

const ConditionsPage = () => (
  <Wrapper>
    <div className="conditions-wrapper">
      <h1>Правила проживания с домашними животными</h1>
      <p>
        Проживание домашнего животного в номере базы отдыха «Золотая Звезда»
        (далее – База отдыха) разрешается при соблюдении следующих Правил.
      </p>
      <p>1. Общие положения.</p>
      <ul>
        <li>
          Домашнее животное – это мелкие породы собак весом до 10 кг и не более
          25-30 см по холке.
        </li>
        <li>
          Администрация Базы отдыха оставляет за собой право определять
          возможность проживания домашнего животного в номере, а также оставляет
          за собой право отказать в размещении без объяснения причин.
        </li>
        <li>
          Гости с домашними животными размещаются по предварительному
          бронированию.
        </li>
        <li>
          На Базе отдыха запрещено проживание с дикими животными или животными,
          представляющими потенциальную опасность для жизни и здоровья человека.
        </li>
        <li>
          Размещение с домашними животными разрешается при наличии ветеринарных
          документов установленного образца (ветеринарного паспорта или справки
          от ветеринарного врача) с отметкой обо всех сделанных прививках.
        </li>
        <li>
          На Базе отдыха разрешено проживание с домашними животными –
          собаками-поводырями, обслуживающими нужды людей с ограниченными
          возможностями.
        </li>
        <li>
          Перед бронированием номера владелец домашнего животного должен в
          обязательном порядке известить администрацию о виде, породе своего
          питомца (в том числе: возрасте, размере).
        </li>
        <li>
          При поселении Базы отдыха с домашними животными владелец обязан
          ознакомиться с «Правилами проживания гостей с домашними животными» и
          поставить свою подпись, подтверждающую согласие с данными правилами.
        </li>
        <li>
          В одном номере разрешается проживание не более одного домашнего
          животного.
        </li>
        <li>
          Со стоимостью проживания животного на Базе отдыха можно ознакомиться в
          прайсе.
        </li>
      </ul>

      <p>2. Обязательства владельца домашнего животного.</p>
      <p>
        Гость, проживающий с животным, берет на себя обязательства по
        обеспечению соблюдения санитарно-гигиенического режима в номере и на
        территории Базы отдыха.
      </p>
      <ul>
        <li>
          Владелец обязан иметь при себе специальный коврик или клетку,
          специальную посуду для кормления, лоток для туалета.
        </li>
        <li>
          На территории Базы отдыха собаки должны находиться исключительно в
          наморднике и на поводке либо в специальной клетке.
        </li>
        <li>
          Допускается нахождение декоративных пород на поводке или на руках
          владельца.
        </li>
        <li>
          Владелец обязан уведомить администрацию о нахождении животного в
          номере без присмотра.
        </li>
      </ul>

      <p>
        3. Ограничения, накладываемые администрацией, на проживание с домашними
        животными.
      </p>
      <ul>
        <li>
          Запрещается кормить домашних животных из посуды, принадлежащей Базе
          отдыха.
        </li>
        <li>Запрещается пользоваться кроватями для отдыха животных.</li>
        <li>
          Запрещается при отсутствии специальной клетки оставлять домашних
          животных без присмотра в номере, других местах общественного
          пользования, на территории Базы отдыха.
        </li>
        <li>Не допускается присутствие животных на территории кафе, бара.</li>
        <li>Запрещен выгул домашних животных на газонах.</li>
        <li>
          Запрещается мыть домашних животных в душевых кабинах, использовать для
          гигиены животных полотенца, простыни и другие постельные
          принадлежности, принадлежащие Базе отдыха.
        </li>
        <li>
          Запрещается вычесывать домашних животных в номере и на его территории.
        </li>
      </ul>

      <p>4. Ответственность владельца домашнего животного.</p>
      <ul>
        <li>
          Владелец берет на себя полную ответственность по решению проблем
          питания, чистки, выгула животного.
        </li>
        <li>
          Владелец несет полную ответственность за возможную порчу домашними
          животными имущества Базы отдыха.
        </li>
        <li>
          В случае порчи имущества домашним животным владелец возмещает ущерб по
          Прейскуранту, действующему на момент проживания владельца животного.
        </li>
        <li>
          Владелец несет всю ответственность за уборку продуктов
          жизнедеятельности животного.
        </li>
        <li>
          Владелец несет все риски перед Базой отдыха и третьими лицами,
          связанные и исходящие из поведения животных, а также времени и условий
          их нахождения в номерном фонде Базы отдыха.
        </li>
      </ul>

      <p>
        5. Условия расторжения договора с гостем, проживающим с домашними
        животными.
      </p>
      <p>
        Администрация оставляет за собой право запретить размешение с животным:
        в случае нарушения «Правил проживания с домашними животными»,
        агрессивного, неадекватного, шумного поведения домашнего животного, при
        создании неудобств домашним животным комфортному проживанию гостей и
        посетителей Базы отдыха.
      </p>
    </div>
  </Wrapper>
)

export default ConditionsPage
